var state = {
  serviceUrl: '',
  // 重定向地址
  appConfig: {},
  // app自定义配置
  appConfigValid: true,
  // 账号探活
  oaProbeInfo: {}
};
var mutations = {
  SET_SERVICE_URL: function SET_SERVICE_URL(state, params) {
    state.serviceUrl = params;
  },
  SET_APP_CONFIG: function SET_APP_CONFIG(state, params) {
    state.appConfig = params;
  },
  SET_APPCONFIG_VALID: function SET_APPCONFIG_VALID(state, bool) {
    state.appConfigValid = bool;
  },
  SET_OA_PROBE_INFO: function SET_OA_PROBE_INFO(state, info) {
    state.oaProbeInfo = info;
  }
};
var actions = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};